module.exports = "<table *mobxAutorun>\n  <tr *ngFor=\"let row of game.board; let i = index\">\n    <td *ngFor=\"let cell of row; let j = index\">\n      <app-cell [value]=\"cell\" [nextValue]=\"game.currentPlayer\" (select)=\"playCell(i,j)\"></app-cell>\n    </td>\n  </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/board/board.component.html
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/tic-tac-toe/board/board.component.html
// module chunks = main